import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex min-h-[calc(100vh-5rem-2rem)] max-h-[calc(100vh-5rem-2rem)] relative overflow-hidden" }
const _hoisted_2 = { class: "bg-gray-200 rounded-l-md p-2 sm:p-4 min-w-[12rem] max-w-[12rem] md:min-w-[16rem] md:max-w-[16rem] hidden sm:block relative" }
const _hoisted_3 = { class: "flex items-center justify-between text-gray-400" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  for: "",
  class: "text-start my-2"
}, "Note", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", { class: "border-none h-[1px] bg-gray-300 w-full mt-2 mb-4" }, null, -1)
const _hoisted_6 = { class: "flex flex-col justify-between overflow-y-auto hide-scrollbar min-h-[calc(100%-3.75rem)] max-h-[calc(100%-3.75rem)]" }
const _hoisted_7 = { class: "block relative" }
const _hoisted_8 = { class: "overflow-hidden text-ellipsis whitespace-nowrap" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "New Note", -1)
const _hoisted_10 = {
  key: 0,
  class: "absolute z-30 w-full h-full opacity-10 bg-black top-12 sm:top-0 sm:left-[12rem] md:left-[16rem] cursor-not-allowed"
}
const _hoisted_11 = { class: "w-full bg-gray-200 rounded-md sm:rounded-l-none sm:rounded-r-md p-2 sm:p-4 overflow-x-hidden" }
const _hoisted_12 = { class: "flex items-center gap-2 sm:hidden" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", { class: "border-none h-[1px] bg-gray-300 w-full my-2 sm:hidden" }, null, -1)
const _hoisted_14 = { class: "sm:flex sm:items-center sm:gap-4 sm:justify-between mb-2 sm:mb-4" }
const _hoisted_15 = { class: "sm:hidden w-full flex items-center gap-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "max-[400px]:!hidden" }, "Reset", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "max-[400px]:!hidden" }, "Delete", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "max-[400px]:!hidden" }, "Save", -1)
const _hoisted_19 = { class: "flex items-center w-full sm:max-w-md my-2 sm:my-0 gap-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-black mr-1 relative -translate-y-[1px]" }, "Title :", -1)
const _hoisted_21 = { class: "text-gray-300" }
const _hoisted_22 = { class: "hidden sm:flex sm:w-fit sm:items-center sm:gap-2" }

import { HttpStatusCode } from 'axios';
import { ref, onMounted, watch, createVNode } from 'vue';
import { useStore } from 'vuex';
import { Button, Input, Modal, Select, Tooltip } from 'ant-design-vue';
import {
	LoadingOutlined,
	DeleteOutlined,
	FileTextOutlined,
	PlusCircleOutlined,
	PlusOutlined,
	ReloadOutlined,
	RollbackOutlined,
	SaveOutlined,
	StarOutlined,
	StarFilled,
	DeleteFilled
} from '@ant-design/icons-vue';
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import DraggableComponent from '@/components/shared/DraggableComponent.vue';
import type { Note } from '@/model/note';
import {
	getNote,
	getNoteList,
	saveNote,
	deleteNote,
	favoriteNote,
	reorderingNote
} from '@/repository/note';

const titleMaxLength = 30;
const reorderingType: 'insert' | 'swap' = 'swap';

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const store = useStore();

const initializeNote: Note = { title: '', content: '', isFavorite: false };
const isLoading = ref(true);
const isResetLoading = ref(false);
const isSaveLoading = ref(false);
const notes = ref<Note[]>([]);
const note = ref<Note>(initializeNote);
const current = ref(-1);
const options = ref([] as { value: string; label: string }[]);
const option = ref({ value: '', label: '' });
const toolbar = [
	[{ header: [1, 2, 3, false] }],
	['bold', 'italic', 'underline'],
	['link', 'image', 'video'],
	[{ list: 'ordered' }, { list: 'bullet' }],
	['blockquote', 'code-block'],
	[{ color: [] }, { background: [] }]
	// https://quilljs.com/docs/modules/toolbar/
];

onMounted(() => {
	resizeNoteEditor();
	fetchData();
});

async function fetchData() {
	isLoading.value = true;
	const noteList = await getNoteList();
	if (noteList?.length) {
		notes.value = noteList.map((note) => {
			return { ...note };
		});
		if (current.value === 0) {
			note.value = notes.value[0];
		}
		current.value = 0;
	} else {
		notes.value = [];
		current.value = -1;
	}
	isLoading.value = false;
}

async function saveItem() {
	if (isSaveLoading.value || !notes.value || !notes.value.length) {
		return;
	}
	try {
		isSaveLoading.value = true;
		await saveNote(note.value);
		store.dispatch('alert', { type: 'success', message: 'save note successfully!' });
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: error ?? 'something went wrong, please try again!'
		});
	} finally {
		isSaveLoading.value = false;
	}
}

async function resetItem() {
	if (isResetLoading.value || !notes.value || !notes.value.length) {
		return;
	}
	isResetLoading.value = true;
	const res = await getNote(note.value.noteUUID || '');
	if (res.data) {
		note.value = res.data;
		notes.value[current.value] = note.value;
	} else {
		store.dispatch('alert', { type: 'warning', message: 'this note has been deleted!' });
		notes.value = notes.value.filter((noteItem) => noteItem.noteUUID !== note.value.noteUUID);
		if (notes.value.length > 0) {
			current.value = 0;
			note.value = notes.value[0];
		} else {
			await fetchData();
		}
	}
	updateTitle();
	isResetLoading.value = false;
}

async function favoriteItem() {
	if (current.value < 0 || !notes.value || !notes.value.length) {
		return;
	}

	note.value.isFavorite = !note.value.isFavorite;

	if (note.value.noteUUID) {
		const res = await favoriteNote(note.value.noteUUID, note.value.isFavorite);
		if (res.status !== HttpStatusCode.Ok) {
			store.dispatch('alert', { type: 'warning', message: 'this note has been deleted already!' });
			await fetchData();
		}
	}
}

function changeItem(item: { noteUUID?: string; index?: number }) {
	if (item.noteUUID !== undefined) {
		current.value = notes.value.findIndex((noteItem) => noteItem.noteUUID === item.noteUUID);
	} else if (item.index !== undefined) {
		current.value = item.index;
	}
}

async function addItem() {
	if (isLoading.value) {
		return;
	}

	isLoading.value = true;

	const newNote = { ...initializeNote };
	newNote.noteUUID = await saveNote(initializeNote);

	notes.value = [...notes.value, { ...newNote }];

	if (notes.value.length === 1) {
		current.value = 0;
	}

	isLoading.value = false;
}

async function deleteItem() {
	if (!notes.value || !notes.value.length) {
		return;
	}
	Modal.confirm({
		title: 'Delete Note',
		icon: createVNode(DeleteFilled),
		content: `Do you want to delete note: ${note.value.title || 'New Note'} right?`,
		okText: 'Yes',
		cancelText: 'No',
		async onOk() {
			const noteUUID = note.value.noteUUID;
			if (noteUUID) {
				await deleteNote(noteUUID);
				notes.value = notes.value.filter((note) => note.noteUUID !== noteUUID) || [];
				if (notes.value.length > 0) {
					current.value = 0;
					note.value = notes.value[0];
				} else {
					notes.value = [];
					current.value = -1;
				}
			}
			store.dispatch('alert', { type: 'success', message: 'delete note successfully!' });
		}
	});
}

const noteEditor = ref<HTMLDivElement>();
window.addEventListener('resize', resizeNoteEditor);
function resizeNoteEditor() {
	if (noteEditor.value) {
		const rect = noteEditor.value.getBoundingClientRect();
		if (noteEditor.value.childNodes.length >= 4) {
			const toolbar = noteEditor.value.childNodes.item(2) as HTMLDivElement;
			const editor = noteEditor.value.childNodes.item(3) as HTMLDivElement;
			const height = window.innerHeight - rect.y - 34 - toolbar.clientHeight;
			editor.style.minHeight = `${height}px`;
			editor.style.maxHeight = `${height}px`;
		}
	}
}

watch(
	() => current.value,
	() => (note.value = current.value >= 0 ? notes.value[current.value] : { ...initializeNote })
);
watch(
	() => note.value,
	() => {
		if (!note.value.content) {
			note.value.content = '<p></p>';
		}
		option.value = {
			value: note.value.noteUUID || '',
			label: note.value.noteUUID ? 'Note: ' + (note.value.title || 'New Note') : ''
		};
	}
);
watch(
	() => notes.value,
	() => reOptions()
);

function reOptions() {
	options.value = notes.value.map((noteItem) => {
		return {
			value: noteItem.noteUUID || '',
			label: noteItem.title || 'New Note'
		};
	});
}

function updateTitle() {
	if (!notes.value || !notes.value.length) {
		note.value.title = '';
		return;
	}
	options.value = options.value.map((opt) => {
		if (opt.value === note.value.noteUUID) {
			opt.label = note.value.title || 'New Note';
			option.value.label = `Note: ${note.value.title || 'New Note'}`;
		}
		return opt;
	});
}

async function dragItem(fromUUID: string, toUUID: string) {
	if (fromUUID === toUUID || isLoading.value) {
		return;
	}

	let fromIndex = notes.value.findIndex((noteItem) => noteItem.noteUUID === fromUUID);
	let toIndex = notes.value.findIndex((noteItem) => noteItem.noteUUID === toUUID);

	if (!toUUID && reorderingType === 'insert') {
		toIndex = -2;
	}

	if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) {
		return;
	}

	if (
		reorderingType === 'insert' &&
		((toIndex === -2 && fromIndex === notes.value.length - 1) || fromIndex + 1 === toIndex)
	) {
		return;
	}

	isLoading.value = true;

	if (reorderingType === 'insert') {
		notes.value = insertNote(notes.value, fromIndex, toIndex);
	} else if (reorderingType === 'swap') {
		swapNote(notes.value, fromIndex, toIndex);
	}

	reOptions();
	notes.value.forEach((noteItem, index) => {
		if (noteItem.noteUUID === note.value.noteUUID) {
			current.value = index;
		}
	});

	await reorderingNote(
		notes.value.map((note, index) => {
			return {
				noteUUID: note.noteUUID || '',
				sequence: index + 1
			};
		})
	);

	isLoading.value = false;
}

function insertNote(notes: Note[], fromIndex: number, toIndex: number) {
	const tempNotes: Note[] = [];
	for (let i = 0; i < notes.length; i++) {
		if (i === toIndex) {
			tempNotes.push({ ...notes[fromIndex] });
		}
		if (i !== fromIndex) {
			tempNotes.push({ ...notes[i] });
		}
	}
	if (toIndex === -2) {
		tempNotes.push({ ...notes[fromIndex] });
	}
	return tempNotes.map((note) => {
		return { ...note };
	});
}

function swapNote(notes: Note[], fromIndex: number, toIndex: number) {
	const noteTemp = { ...notes[fromIndex] };
	notes[fromIndex] = { ...notes[toIndex] };
	notes[toIndex] = { ...noteTemp };
}

function focusEditor() {
	const quillEditor = document.getElementById('quill-editor');
	if (quillEditor && quillEditor.children.length > 0) {
		const editor = quillEditor.children.item(0) as HTMLDivElement;
		editor?.focus();
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (!isLoading.value)
          ? (_openBlock(), _createBlock(_unref(ReloadOutlined), {
              key: 0,
              onClick: fetchData
            }))
          : (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 1 }))
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notes.value, (noteItem, index) => {
            return (_openBlock(), _createBlock(DraggableComponent, {
              key: index,
              id: noteItem.noteUUID || '',
              type: reorderingType,
              "drag-group-class": "note-reordering",
              class: _normalizeClass(
							'cursor-pointer text-start rounded-md p-2 hover:bg-gray-300 flex items-center gap-2 overflow-y-auto overflow-x-hidden' +
							(noteItem.noteUUID === note.value.noteUUID && !noteItem.title
								? ' !bg-gray-400 text-gray-300'
								: noteItem.noteUUID === note.value.noteUUID
									? ' !bg-gray-400 text-white'
									: !noteItem.title
										? ' text-gray-400'
										: '')
						),
              onClick: () => changeItem({ index }),
              onDrop: dragItem
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FileTextOutlined)),
                _createElementVNode("div", _hoisted_8, _toDisplayString(noteItem.title || 'New Note'), 1),
                (noteItem.isFavorite)
                  ? (_openBlock(), _createBlock(_unref(StarFilled), {
                      key: 0,
                      class: "text-yellow-400 ml-auto"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["id", "class", "onClick"]))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: "flex items-center gap-2 p-2 cursor-pointer hover:bg-gray-300 rounded-md",
          onClick: addItem
        }, [
          _createVNode(_unref(PlusCircleOutlined)),
          _hoisted_9
        ])
      ])
    ]),
    (!notes.value || !notes.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_unref(Select), {
          class: "w-full text-start",
          value: option.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((option).value = $event)),
          options: options.value,
          onChange: _cache[1] || (_cache[1] = (item) => changeItem({ noteUUID: `${item}` }))
        }, null, 8, ["value", "options"]),
        _createVNode(_unref(Tooltip), {
          placement: "top",
          title: "Reload"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              class: "min-w-[2rem] border-none bg-violet-300 hover:bg-violet-500 !text-black",
              onClick: fetchData
            }, {
              icon: _withCtx(() => [
                (!isLoading.value)
                  ? (_openBlock(), _createBlock(_unref(ReloadOutlined), { key: 0 }))
                  : (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 1 }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(Tooltip), {
          placement: "top",
          title: "Add"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              class: "min-w-[2rem] border-none bg-cyan-300 hover:bg-cyan-400 !text-black",
              onClick: addItem
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(PlusOutlined))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_unref(Tooltip), {
            placement: "top",
            title: "Reset"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                class: "w-full border-none",
                type: "primary",
                onClick: resetItem
              }, {
                icon: _withCtx(() => [
                  (isResetLoading.value)
                    ? (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 0 }))
                    : (_openBlock(), _createBlock(_unref(RollbackOutlined), { key: 1 }))
                ]),
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(Tooltip), {
            placement: "top",
            title: "Delete"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                class: "w-full border-none bg-red-400 hover:bg-red-500 hover:!text-white",
                onClick: deleteItem
              }, {
                icon: _withCtx(() => [
                  _createVNode(_unref(DeleteOutlined))
                ]),
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(Tooltip), {
            placement: "top",
            title: "Save"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                class: "w-full border-none bg-green-400 hover:bg-green-500 hover:!text-white",
                onClick: saveItem
              }, {
                icon: _withCtx(() => [
                  (!isSaveLoading.value)
                    ? (_openBlock(), _createBlock(_unref(SaveOutlined), { key: 0 }))
                    : (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 1 }))
                ]),
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_unref(Input), {
            value: note.value.title,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((note.value.title) = $event)),
            class: "text-base",
            maxlength: titleMaxLength,
            placeholder: "Enter a title of note",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (updateTitle())),
            disabled: !notes.value || notes.value.length === 0
          }, {
            prefix: _withCtx(() => [
              _hoisted_20
            ]),
            suffix: _withCtx(() => [
              _createElementVNode("span", _hoisted_21, _toDisplayString(note.value.title?.length || 0) + "/" + _toDisplayString(titleMaxLength), 1)
            ]),
            _: 1
          }, 8, ["value", "disabled"]),
          _createVNode(_unref(Tooltip), {
            placement: "top",
            title: "Favorite"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                class: "min-w-[2rem] border-none bg-yellow-400 hover:bg-yellow-500 !text-orange-600",
                onClick: favoriteItem
              }, {
                icon: _withCtx(() => [
                  (!note.value.isFavorite)
                    ? (_openBlock(), _createBlock(_unref(StarOutlined), { key: 0 }))
                    : (_openBlock(), _createBlock(_unref(StarFilled), { key: 1 }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_unref(Tooltip), {
            placement: "top",
            title: "Reset"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                class: "min-w-[2rem] border-none",
                type: "primary",
                onClick: resetItem
              }, {
                icon: _withCtx(() => [
                  (isResetLoading.value)
                    ? (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 0 }))
                    : (_openBlock(), _createBlock(_unref(RollbackOutlined), { key: 1 }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(Tooltip), {
            placement: "top",
            title: "Delete"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                class: "min-w-[2rem] border-none bg-red-400 hover:bg-red-500 hover:!text-white",
                onClick: deleteItem
              }, {
                icon: _withCtx(() => [
                  _createVNode(_unref(DeleteOutlined))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(Tooltip), {
            placement: "top",
            title: "Save"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                class: "min-w-[2rem] border-none bg-green-400 hover:bg-green-500 hover:!text-white",
                onClick: saveItem
              }, {
                icon: _withCtx(() => [
                  (!isSaveLoading.value)
                    ? (_openBlock(), _createBlock(_unref(SaveOutlined), { key: 0 }))
                    : (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 1 }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", {
        ref_key: "noteEditor",
        ref: noteEditor,
        class: "bg-white text-black rounded-md",
        style: _normalizeStyle(!notes.value || !notes.value.length ? 'background-color: rgba(0, 0, 0, 0.04);' : '')
      }, [
        _createVNode(_unref(QuillEditor), {
          theme: "snow",
          id: "quill-editor",
          class: "cursor-text !text-base overflow-auto min-h-[calc(100vh-5rem-10rem)] max-h-[calc(100vh-5rem-10rem)] whitespace-nowrap break-all",
          placeholder: "Enter some note",
          "content-type": "html",
          toolbar: toolbar,
          content: note.value.content,
          "onUpdate:content": _cache[4] || (_cache[4] = ($event: any) => ((note.value.content) = $event)),
          enable: notes.value && notes.value.length > 0,
          "read-only": !notes.value || notes.value.length === 0,
          onClick: focusEditor
        }, null, 8, ["content", "enable", "read-only"])
      ], 4)
    ])
  ]))
}
}

})